import { useMemo } from "react";

import { PERMISSIONS } from "../../types/auth";
import { useAuth } from "../AuthContext";

/**
 * Strict `billing` group membership check used to gate the analytics/usage
 * Dashboard. Unlike {@link useHasPermission}, this deliberately does NOT honour
 * the admin/superuser bypass in checkPermission — a user must actually be in the
 * Cognito/Django `billing` group to qualify. An admin who is not in the billing
 * group does not see the Dashboard.
 */
export const useIsBillingMember = (): boolean => {
  const { user } = useAuth();

  return useMemo(
    () => !!user?.backend?.groups?.includes(PERMISSIONS.billing),
    [user],
  );
};
